'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculatePace = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.calculatePace = calculatePace;

var _sprintfJs = require('sprintf-js');

function formatNum(num, digits) {
  return (0, _sprintfJs.sprintf)('%0' + digits + 'd', Math.floor(num));
}

function displayTime(rate) {
  var hours = rate / 3600;
  var mins = hours % 1 * 60;
  var secs = mins % 1 * 60;

  return [formatNum(hours, 1), formatNum(mins, hours >= 1 ? 2 : 1), formatNum(secs, 2)];
}

var typeMapping = {
  '5k run': 'running',
  'adventure racing': 'offroadrun', //bad ux (might want unique picture for this)
  aquabike: 'swimming',
  aquathlon: 'swimming',
  criterium: 'biking',
  cycling: 'biking',
  cyclocross: 'offroadbike',
  'fun run': 'funrun',
  'half-marathon': 'running',
  marathon: 'running',
  'mountain biking': 'offroadbike',
  'mountain climb': 'offroadrun',
  'non-athletic (untimed)': 'funrun',
  'off-road aquabike': 'swimmingoutdoor',
  'off-road duathlon': 'offroadrun',
  'off-road triathlon': 'offroadrun', //bad ux (show running and biking on pavement)
  orienteering: 'offroadrun',
  'race walking': 'running',
  'ski - cross country': 'crosscountryski',
  'snowshoe running': 'running', //bad ux (show people running on pavement not snow)
  'trail running': 'offroadrun',
  'trail running & hiking': 'offroadrun',
  untimed: 'funrun'
};

var raceTypeMap = {
  running: function running(m, s, asArray) {
    var _displayTime = displayTime(s / (0.000621371 * m));

    var _displayTime2 = _slicedToArray(_displayTime, 3);

    var hours = _displayTime2[0];
    var mins = _displayTime2[1];
    var secs = _displayTime2[2];

    var time = (hours != '0' ? hours + ':' : '') + (mins + ':' + secs);
    var units = 'Min/Mile';
    return asArray ? [time, units] : time + ' ' + units;
  },
  offroadrun: function offroadrun(m, s, a) {
    return raceTypeMap.running(m, s, a);
  },
  other: function other(m, s, a) {
    return raceTypeMap.running(m, s, a);
  },
  funrun: function funrun(m, s, a) {
    return raceTypeMap.running(m, s, a);
  },
  obstacle: function obstacle(m, s, a) {
    return raceTypeMap.running(m, s, a);
  },
  crosscountryski: function crosscountryski(m, s, a) {
    return raceTypeMap.running(m, s, a);
  },
  swimming: function swimming(m, s, asArray) {
    var _displayTime3 = displayTime(s * 100 / (1.09361 * m));

    var _displayTime4 = _slicedToArray(_displayTime3, 3);

    var hours = _displayTime4[0];
    var mins = _displayTime4[1];
    var secs = _displayTime4[2];

    var time = (hours != '0' ? hours + ':' : '') + (mins + ':' + secs);
    var units = 'Min/100Yd';
    return asArray ? [time, units] : time + ' ' + units;
  },
  swimmingindoor: function swimmingindoor(m, s, a) {
    return raceTypeMap.swimming(m, s, a);
  },
  swimmingoutdoor: function swimmingoutdoor(m, s, a) {
    return raceTypeMap.swimming(m, s, a);
  },
  cycling: function cycling(m, s, asArray) {
    var mph = 0.000621371 * m / (s / 3600);
    var time = (0, _sprintfJs.sprintf)('%.02f', mph);
    var units = 'MPH';
    return asArray ? [time, units] : time + ' ' + units;
  },
  biking: function biking(m, s, a) {
    return raceTypeMap.cycling(m, s, a);
  },
  offroadbike: function offroadbike(m, s, a) {
    return raceTypeMap.cycling(m, s, a);
  }
};

function calculatePace(tuple, ticks, asArray) {
  var secs = ticks / 1000;
  var meters = tuple.meters;
  var type = tuple.type.toLowerCase();

  var pace = raceTypeMap[type] || raceTypeMap[typeMapping[type]];
  return typeof pace === 'function' ? pace(meters, secs, asArray) : null;
}

// For testing.
var CalculatePace = exports.CalculatePace = {
  calculatePace: calculatePace
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/CalculatePace.js
// module id = 418
// module chunks = 0